export interface IPromotionPeriod {
  start: Date
  end: Date
  isActive: boolean
}

/**
 * Builds a promotion period that starts now and runs until the given end date
 * (inclusive, up to 23:59:59.999 on that day).
 *
 * e.g. getPromotionPeriod(new Date('2026-09-01')) returns a period
 *      ending 2026-09-01T23:59:59.999
 *
 * @param endDate - the last day the promotion is active
 * @param from - the start of the period (defaults to now)
 * @returns {IPromotionPeriod}
 */
export function getPromotionPeriod(endDate: Date, from: Date = new Date()): IPromotionPeriod {
  const start = new Date(from.getTime())

  const end = new Date(
    endDate.getFullYear(),
    endDate.getMonth(),
    endDate.getDate(),
    23, 59, 59, 999,
  )

  const now = new Date()

  return {
    start,
    end,
    isActive: now.getTime() >= start.getTime() && now.getTime() <= end.getTime(),
  }
}

